var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.i18n(_vm.label),"outlined":_vm.outlined,"readonly":_vm.readonly,"autofocus":_vm.autofocus,"prepend-inner-icon":_vm.icon,"hide-details":_vm.hideDetails,"x-small":""},model:{value:(_vm.str),callback:function ($$v) {_vm.str=$$v},expression:"str"}})
}
var staticRenderFns = []

export { render, staticRenderFns }